var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBalanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8686_9330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5C6.5 10.9477 6.05228 10.5 5.5 10.5C4.94772 10.5 4.5 10.9477 4.5 11.5V16.5C4.5 17.0523 4.94772 17.5 5.5 17.5C6.05228 17.5 6.5 17.0523 6.5 16.5V11.5ZM12.5 11.5C12.5 10.9477 12.0523 10.5 11.5 10.5C10.9477 10.5 10.5 10.9477 10.5 11.5V16.5C10.5 17.0523 10.9477 17.5 11.5 17.5C12.0523 17.5 12.5 17.0523 12.5 16.5V11.5ZM21 20.5C21 19.9477 20.5523 19.5 20 19.5H3C2.44771 19.5 2 19.9477 2 20.5C2 21.0523 2.44772 21.5 3 21.5H20C20.5523 21.5 21 21.0523 21 20.5ZM18.5 11.5C18.5 10.9477 18.0523 10.5 17.5 10.5C16.9477 10.5 16.5 10.9477 16.5 11.5V16.5C16.5 17.0523 16.9477 17.5 17.5 17.5C18.0523 17.5 18.5 17.0523 18.5 16.5V11.5ZM11.0345 4.00479C11.3259 3.85155 11.6741 3.85155 11.9655 4.00479L16.71 6.5H6.29L11.0345 4.00479ZM11.9657 1.74513C11.6742 1.59169 11.3258 1.59169 11.0343 1.74513L2.53425 6.21881C2.2057 6.39174 2 6.73245 2 7.10373V7.5C2 8.05228 2.44772 8.5 3 8.5H20C20.5523 8.5 21 8.05228 21 7.5V7.10373C21 6.73245 20.7943 6.39174 20.4657 6.21881L11.9657 1.74513Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8686_9330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceIcon);
export default __webpack_public_path__ + "static/media/AccountBalanceIcon.16f77225a60284d2c321d7c5485f004c.svg";
export { ForwardRef as ReactComponent };